<template>
    <div>
        <az-call-to-action dark
                           active
                           @click="abrirConfirmacaoRefazerLicitacao">
            Refazer Pregão
        </az-call-to-action>
        <az-confirm @onConfirm="refazerLicitacao"
                    @onDecline="fecharConfirmacaoRefazerLicitacao"
                    label-decline="Cancelar"
                    v-if="mostrarDialog" :maxWidth=380>
            <div style=" display: flex; flex-direction: column;">
                <span>Essa ação vai refazer a sessão do Pregão somente para os lotes que não foram <strong>Adjudicados, Unificados e Homologados.</strong></span>
                <span>Após confirmar a ação, será necessário realizar a Publicação para que essa nova sessão do pregão fique disponível e receba propostas.</span>
                <br>
                <span style="text-align: center">Deseja Continuar?</span>
            </div>
        </az-confirm>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {actionTypes, exceptions, mutationTypes} from '@/commons/constants'

    export default {
        name: 'LicitacaoAtualizacaoAcoesRefazer',
        data() {
            return {
                globalLoadingAtivado: false,
                mostrarDialog: false
            }
        },
        computed: {
            ...mapState(['licitacao', 'loki'])
        },
        methods: {
            abrirConfirmacaoRefazerLicitacao() {
                this.mostrarDialog = true
            },
            fecharConfirmacaoRefazerLicitacao() {
                this.mostrarDialog = false
            },
            desabilitarLoading() {
                if (!this.globalLoadingAtivado) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async refazerLicitacao() {
                this.fecharConfirmacaoRefazerLicitacao()
                this.habilitarLoading()
                try {
                    const licitacao = await this.$store.dispatch(actionTypes.REFAZER_LICITACAO, this.licitacao.id)
                    await this.$store.dispatch(actionTypes.BUSCAR_LICITACAO,this.licitacao.id)

                    this.$router.push({name: 'licitacao', params: {id: licitacao.id}, query: {edicao: true}})
                    this.$router.go()
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoading()
                } catch (err) {
                    const exception = err.response ? exceptions[err.response.data.exception] : undefined
                    if (exception && exception.ignorarNotificacaoDefault) {
                        this.$store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO ,err.response.data.message)
                    }
                    this.desabilitarLoading()
                }
            },
            habilitarLoading() {
                this.globalLoadingAtivado = this.loki.isGlobalLoadingEnabled
                this.habilitarLoadingGlobal()
            }
        }
    }
</script>